export default function Quality() {
  const standards = [
    {
      icon: 'ri-shield-check-line',
      title: 'WHO-GMP Certified',
      description: 'All our facilities meet World Health Organization Good Manufacturing Practice standards.'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'ISO 9001:2015',
      description: 'Certified quality management systems ensuring consistent product excellence.'
    },
    {
      icon: 'ri-microscope-line',
      title: 'Rigorous Testing',
      description: 'Multi-stage quality control with advanced analytical testing at every production phase.'
    },
    {
      icon: 'ri-user-star-line',
      title: 'Expert Team',
      description: 'Highly qualified quality assurance professionals with decades of combined experience.'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-gray-50 to-teal-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="order-2 lg:order-1 relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="/assets/CultureQuality.jpg"
                alt="Quality Assurance"
                className="w-full h-full object-cover object-center"
              />
            </div>
            <div className="absolute -top-8 -right-8 bg-white rounded-2xl shadow-xl p-6 max-w-xs">
              <div className="flex items-center space-x-4">
                <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-cyan-500 to-teal-500 rounded-xl">
                  <i className="ri-checkbox-circle-line text-white text-3xl"></i>
                </div>
                <div>
                  <div className="text-3xl font-bold text-gray-900">99.9%</div>
                  <div className="text-gray-600 text-sm">Quality Rate</div>
                </div>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2">
            <div className="inline-block bg-cyan-600 text-white px-4 py-2 rounded-full text-sm font-semibold mb-6">
              QUALITY
            </div>
            <h2 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Uncompromising Standards of Excellence
            </h2>
            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
              Quality is not just a goal—it's our promise. We maintain the highest standards in pharmaceutical manufacturing, from raw material sourcing to final product delivery. Every medicine we produce undergoes rigorous testing to ensure safety, efficacy, and reliability.
            </p>
            <div className="space-y-6">
              {standards.map((standard, index) => (
                <div key={index} className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300">
                  <div className="flex items-start space-x-4">
                    <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-cyan-500 to-teal-500 rounded-xl flex-shrink-0">
                      <i className={`${standard.icon} text-white text-2xl`}></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">{standard.title}</h3>
                      <p className="text-gray-600 text-sm leading-relaxed">{standard.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
